module.exports = __webpack_public_path__ + "img/qiche1.60fbe320.png";